<div class="basin-pb-4 basin-width-100">
  <form [formGroup]="form">
    <formly-form
      (keydown)="onKeyDown($event)"
      [form]="form"
      [fields]="fields"
      [model]="model"
    >
    </formly-form>
  </form>
</div>
<div class="basin-display-flex basin-justify-content-end basin-width-100">
  <button
    pButton
    (click)="cancelLoop()"
    label="Cancel"
    class="p-button-text basin-mr-6"
  ></button>
  <button
    pButton
    type="submit"
    [disabled]="model.numberOfIterations < 1 || model.numberOfIterations > maxIterations"
    (click)="startLoop(model)"
    class="p-button-text"
    label="Simulate"
  ></button>
</div>
